// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__27JgT","large":"styles_large__29e8w"};